import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

function QRCodeComponent({ url, size = 128, bgColor = "#ffffff", fgColor = "#22c55e" }) {
  return (
    <div className="flex flex-col items-center">
      <QRCodeSVG 
        value={url} 
        size={size} 
        bgColor={bgColor}
        fgColor={fgColor}
        level="H"
        includeMargin={true}
      />
    </div>
  );
}

export default QRCodeComponent; 